import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, IconButton, Button, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import VisitManagement from '@components/receptionist/VisitManagement';
import { pdfService } from '@services/pdfService';
import { useAuth } from '@contexts/AuthContext';

const VisitEncounter: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [toastMsg, setToastMsg] = useState<string>('');
  const [showBlockDialog, setShowBlockDialog] = useState(false);
  const [exportingPDF, setExportingPDF] = useState(false);

  const handleClose = () => {
    navigate(-1);
  };

  const handleExportPDF = async () => {
    if (!id) return;
    
    try {
      setExportingPDF(true);
      await pdfService.downloadVisitPDF(id, 'consultation');
      setToastMsg('PDF descărcat cu succes');
    } catch (error) {
      setToastMsg('Eroare la generarea PDF');
    } finally {
      setExportingPDF(false);
    }
  };

  if (!id) {
    return (
      <Box sx={{ p: 3 }}>Lipsește ID-ul vizitei.</Box>
    );
  }

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#fafafa' }}>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flex: 1 }}>
            Vizită medicală
          </Typography>
          
          <Button 
            startIcon={<PrintIcon />} 
            onClick={handleExportPDF} 
            disabled={exportingPDF}
            sx={{ mr: 1 }}
            size="small"
          >
            {exportingPDF ? 'Generare...' : 'Export PDF'}
          </Button>
          
          <IconButton edge="end" onClick={handleClose} aria-label="inchide">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Conținut consultatie */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <VisitManagement visitId={id} currentUserId={user?.id || ''} />
      </Box>

      {/* Confirmare la ieșire — poate fi legat de dirty state pe formular când există modificări nesalvate */}
      <Dialog open={showBlockDialog} onClose={() => setShowBlockDialog(false)}>
        <DialogTitle>Modificări nesalvate</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Există modificări nesalvate în consultație. Dacă părăsești acum, toate modificările vor fi pierdute. 
            Sigur vrei să continui?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowBlockDialog(false)} color="primary">
            Anulează
          </Button>
          <Button onClick={() => setShowBlockDialog(false)} color="error" autoFocus>
            Părăsește oricum
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={!!toastMsg} autoHideDuration={2500} onClose={() => setToastMsg('')}>
        <Alert severity="success" variant="filled" sx={{ width: '100%' }}>
          {toastMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default VisitEncounter;
